import { apiFetch } from '@/plugins/api.js';
import { getRuntimeApiUrl } from '@/plugins/hostAwareConfig.js';
export default {
  async getTickets(context) {
    let url =
       `${getRuntimeApiUrl()}/user/tickets`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('getTickets', responseData);

    context.commit('setTickets', responseData.tickets);
    context.commit('updateDatetime');
  },

  async getSubcategories(context) {
    let url =
       `${getRuntimeApiUrl()}/user/tickets/subcategories`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('getSubcategories', responseData);

    context.commit('setSubcategories', responseData.subcategories);
  },

  async getTicket(context, payload) {
    let url =
       `${getRuntimeApiUrl()}/user/tickets/${payload.id}`;

    const response = await apiFetch(url, {
      method: 'GET',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('getTicket ' + payload.id, responseData);

    context.commit('setLoadedTicket', { ticket: responseData.ticket });
    context.commit('updateDatetime');
  },

  async newTicket(context, payload) {
    let url =
       `${getRuntimeApiUrl()}/user/tickets/create`;

    const response = await apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        subcategory: payload.subcategory,
        service: (payload.service === undefined) ? null : payload.service,
        subject: payload.subject,
        text: payload.text
      })
    });

    const responseData = await response.json();

    if (responseData.status_code != 200) {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }
    
    return responseData.newTicket;

  },

  async newMessage(context, payload) {
    let url =
       `${getRuntimeApiUrl()}/user/tickets/${payload.ticket.id}/messages/create`;

    const response = await apiFetch(url, {
      method: 'POST',
      body: JSON.stringify({
        ticket_id: payload.ticket.id,
        text: payload.newMessage.text
      })
    });

    const responseData = await response.json();

    if (responseData.status_code != 200) {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }
    
    return responseData.newMessage;

  },

  async setStatusClosed(context, payload) {
    let url =
      `${getRuntimeApiUrl()}/user/tickets/${payload.id}/close`;

    const response = await apiFetch(url, {
      method: 'POST',
    });

    const responseData = await response.json();

    if (responseData.status_code != '200') {
      const error = new Error(
        responseData.message || 'Failed to authenticate. Check your login data.'
      );
      throw error;
    }

    // console.log('setStatusClosed', responseData);

    context.commit('setLoadedTicket', { ticket: responseData.ticket });
    context.commit('updateDatetime');
  },
};
